import { render } from "./NcrmMailjetListPurposesTab.vue?vue&type=template&id=9e908b6a&scoped=true"
import script from "./NcrmMailjetListPurposesTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetListPurposesTab.vue?vue&type=script&lang=js"

import "./NcrmMailjetListPurposesTab.vue?vue&type=style&index=0&id=9e908b6a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e908b6a"]])

export default __exports__